import { useState } from 'react';

export default function FallbackImage({ src, alt }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className="product-image">
        Nyafaz
        <br />
        Skincare
      </div>
    );
  }

  return (
    <div className="product-image">
      <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
    </div>
  );
}
